const logger = {
    //TODO: Disable log for production builds
    log: (tag, messageObj) => {
        if (console && console.log && typeof (console.log) === "function") {
            console.log(tag, messageObj);
        }
    }
}

export default logger;